import { combineReducers } from 'redux';
import axios from 'axios';
import { stopSubmit, startSubmit } from 'redux-form';
import { CURRENT_CLIENT_FORM } from 'src/constants/FormNames';

import { UPDATE_CLIENT_SETTING_USING_PLAN, COMPLETED_REGIST_SETTING_USING_PLAN } from 'src/constants/EndpointUrls';
import { setItem, setItemError } from 'src/reducers/common/itemReducer';
import createNamedWrapperReducer from 'src/reducers/createNamedWrapperReducer';
import { itemReducer } from 'src/reducers/common';
import { redirectTo } from 'src/utils/Http';

export const REDUCER_NAME = 'currentClient';
export const PLAN_TYPES = {
  trial_plan: 'Trial Plan',
  free_plan: 'Free Plan',
  paid_plan: 'Paid Plan',
  suspended: 'Account suspended'
};

export const isTrialPlan = planType => planType === 'trial_plan';
export const isFreePlan = planType => planType === 'free_plan';
export const isPaidPlan = planType => planType === 'paid_plan';

export const dispatchInitCurrentClient = (dispatch, currentClient) => dispatch(setItem(REDUCER_NAME, currentClient));

export const updateToPaidPlan = data => async dispatch => {
  try {
    dispatch(startSubmit(CURRENT_CLIENT_FORM));
    await axios.post(UPDATE_CLIENT_SETTING_USING_PLAN, data);
    redirectTo(COMPLETED_REGIST_SETTING_USING_PLAN);
  } catch (e) {
    dispatch(setItemError(REDUCER_NAME, e.response.data.errors.messages));
  } finally {
    dispatch(stopSubmit(CURRENT_CLIENT_FORM));
  }
};

export default combineReducers({
  item: createNamedWrapperReducer(itemReducer, REDUCER_NAME)
});
